export class CssGridTemplates {
    public static LEFT_RIGHT = 'left-right-template';
    public static TOP_BOTTOM = 'top-bottom-template';
    public static DOUBLE_GRID = 'double-grid-template';
}
